(function (angular, app) {
    "use strict";
    
   angular.module(app.modules.course.name)
      .factory(app.modules.course.services.search, CourseSearchFactory);
      
   CourseSearchFactory.$inject = [
      app.modules.common.services.http
      , app.modules.common.constants.appsettings
      , app.modules.common.services.functions
   ];
   
   function CourseSearchFactory($http
       , ggSettings
       , ggFunctions
      ) {
      
      var _searchTypes = {
         byCourseName : 1
         , byGPS : 2
         , byIndividual : 3
      }
      
      // Use to set and get when clicking courses
      var _course = {};
      
      var _search = {
         fetchCourseDetail : function(data){
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.course.detail + "(" + data.courseId + ")/getCourseInfo";
            return $http.get(apipath, {});
         }
         , fetchCourseSearch: function (data) {
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.course.search;
            var qry = "?$top=50&$filter="
            var exp = "";
            var ord = "&$orderby=name"
            var is  = false;
            
            var form = angular.copy(data);

            if (form.name && form.name.length > 2 && !isNaN(form.name)) {
                form.postalCode = form.name;
                form.name = null;
            }

            // Search
            if (form.name) {
                if (is) {
                    qry += " and "
                }
                qry += " startswith(name,'" + form.name + "')"
                is = true;
            }

            if (form.postalCode) {
                if (is) {
                    qry += " and "
                }
                qry += " startswith(address/postalCode,'" + form.postalCode + "')"
                //qry += " address/postalCode eq '" + data.postalCode + "'"
                is = true;
            }

            if (form.regioncode) {
               if (is) {
                  qry += " and "
               }
               qry += " address/region eq '" + form.regioncode + "'"
               is = true;
            }

            return $http.get(apipath + qry + exp + ord, {});
            
         }
         , fetchCourseSearchByMember: function (data) {
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.member.detail + "(" + data.memberId + ")";
            var exp = "?$expand=courses";
            var ord = ""
            return $http.get(apipath + exp + ord, {}).then(function (data) {

               if (data && data.status == "200") {
                  var courses = data.data.courses;
                  var rv = {
                     status: "200"
                     , data: {
                        value : courses
                     }
                  }
                  return rv;
               }

            });
         }
         , fetchCourseSearchByGeoCode: function (data) {
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.course.search;

            if (data.latitude) {
               data.latitude = (data.latitude).toFixed(4)
            }
            if (data.longitude) {
               data.longitude = (data.longitude).toFixed(4)
            }

            var qry = "/getCoursesByGeoCode(latitude=" + data.latitude + ",longitude=" + data.longitude + ",radius=25)"
            var exp = "";
            var ord = ""
            var is = false;

            // Fetch
            return $http.get(apipath + qry + exp + ord, {});
         }
      }

      var tees = {
         fetchTees: function (data) {
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.course.tee ;
            var exp = "?$filter=courseId eq " + data.courseId
            var ord = "&$orderby=type,slope desc"
            // Fetch
            return $http.get(apipath + exp + ord, {});
         }
         , fetchTee: function (data) {
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.course.tee + "(" + data.teeId + ")";
            var exp = "?$expand=holes"
            // Fetch
            return $http.get(apipath + exp, {});
         }
      }
      
      var service = {
         searchTypes: _searchTypes
         , search : _search
         , Course: _course
         , tees : tees
      }
      
      return service;
   }
}(angular, app));

